module.exports = __webpack_public_path__ + "img/pakistan_icc.b313474f.png";